const doc = [({"en":({"js":({"admin":({"logs":({"headers":({"create":({"create":"Created"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;